<template>
  <div class="busy-area">
    <div :class="{ invisible: busy }" class="w-full h-full">
      <slot />
    </div>
    <Spinner v-if="busy" class="spinner" />
  </div>
</template>

<script lang="ts" setup>
import Spinner from '../Spinner.vue';

interface Props {
  busy?: boolean;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.busy-area {
  @apply relative;
}
.spinner {
  @apply absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2;
}
</style>
